$('#sidebarCollapse').click(function () {
    $('#sidebar, #content').toggleClass("active")
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
});